import Button from '@/components/Button/newButtons';

const FreeTrialWarningModal = ({
	isOpen,
	onClose
}: {
	isOpen: boolean;
	onClose: () => void;
}) => {
	if (!isOpen) return null;

	return (
		<div className="fixed inset-0 left-0 top-0 z-[2000] flex items-center justify-center overflow-auto bg-black bg-opacity-60">
			<div className="z-100 max-w-sm rounded-lg border border-dm-grey bg-dm-black1 p-6 text-center shadow-lg">
				<h2 className="mb-2 text-xl font-semibold text-dm-white">
					Upgrade Required
				</h2>
				<p className="mb-4 text-dm-white">
					To access this feature you must upgrade your account. Please
					get in contact with Customer Success at{' '}
					<a
						href="mailto:human@re2.ai"
						className="text-blue-500 underline"
					>
						human@re2.ai
					</a>
					.
				</p>
				<div className="flex justify-center">
					<Button variant="primary" onClick={onClose}>
						Close
					</Button>
				</div>
			</div>
		</div>
	);
};

export default FreeTrialWarningModal;
